import type { Component } from 'vue'

export const getComponentName = (key: string) => {
  return String(key.split('/').pop() || key).replace(/\.(\/|vue|[jt]s)/g, '')
}

export const mapModuleDefaults = (modules: Record<string, { default: Component }>): Record<string, Component> => {
  const mapped = {}
  for (const [ key, entry ] of Object.entries(modules)) {
    mapped[getComponentName(key)] = entry.default
  }
  return mapped
}

export const loadModules = (glob) => Object.values(mapModuleDefaults(glob))

export const loadComponents = (glob: Record<string, { default: Component }>) => {
  const modules = mapModuleDefaults(glob)
  return Object.entries(modules).map(([ key, component ]) => {
    if (!component.name) {
      // @ts-ignore
      component.name = key.replace(/(\/|-|_|\s)\w/g, (match) => match.slice(1).toUpperCase())
    }
    return component
  })
}

export const loadAsyncComponents = (glob: Record<string, () => Promise<Component>>): Array<[ string, () => Promise<Component> ]> => {
  return Object.entries(glob).map(([ key, importFn ]) => {
    return [
      getComponentName(key),
      importFn
    ]
  })
}
